/* eslint-disable react/require-default-props */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import CommentItem from 'components/molecules/comment_item';
import { BiddingState, CommentDataTypes } from 'store/modules/bidding_store/types';
import CommentInput from 'components/molecules/comment_input';
import { CommentProps, createComment } from 'store/modules/bidding_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import { createCommentBulletin } from 'store/modules/bulletins_store/actions';
import { BulletinsState, IndividualCommentRequestState } from 'store/modules/bulletins_store/types';
import tabId from 'services/tabId';

interface BiddingCommentsListProps {
  biddingId: number;
  comments: Array<CommentDataTypes>;
  bulletinFilterId?: number;
  source?: 'biddings' | 'management' | 'imminence' | 'bulletin';
}

const BiddingCommentsList = (props: BiddingCommentsListProps) => {
  const { biddingId, comments, bulletinFilterId = 0, source = 'biddings' } = props;

  const dispatch = useDispatch();

  const { comments_request } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const bulletin_comments_request = useSelector<ApplicationState, IndividualCommentRequestState>(
    (state) => state.session.bulletins.comments_request,
  );

  const { bulletins } = useSelector<ApplicationState, BulletinsState>(
    (state) => state.session.bulletins,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const createBiddingComment = (comment: string, commentSource: string) => {
    let data: CommentProps = {
      bidding_comment: {
        bidding_id: biddingId,
        message: comment,
      },
    };

    if (profile.representant && profile.currentCompany[tabId()] !== profile.clientId) {
      data = {
        bidding_comment: {
          ...data.bidding_comment,
          client_id: profile.currentCompany[tabId()],
        },
      };
    }

    if (commentSource === 'bulletin')
      dispatch(createCommentBulletin(biddingId, profile.name, data, profile.id, bulletinFilterId));

    if (commentSource === 'biddings')
      dispatch(createComment(biddingId, profile.name, data, profile.id));
  };

  const bulletinBiddingComments = () => {
    const bulletinBiddingIndex = bulletins.bulletins_biddings_list[
      bulletinFilterId
    ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(biddingId));

    return bulletins.bulletins_biddings_list[bulletinFilterId].biddings[bulletinBiddingIndex]
      ?.client_comments;
  };

  return (
    <div className="bidding-info tour-bidding-notes d-print-none">
      <div className="col-md-2 p-0 bidding-info-title mb-1 font-weight-bold">Anotações</div>
      <div className="col-md-12 p-0">
        {source !== 'bulletin' &&
          comments?.map((comment) => (
            <CommentItem
              key={comment.id}
              id={comment.id}
              contact_client_id={comment.contact_client.id}
              contact_client_nome={comment.contact_client.nome}
              created_at={comment.created_at}
              message={comment.message}
              biddingId={biddingId.toString()}
              commentSource={source}
              bulletinFilterId={bulletinFilterId}
            />
          ))}
        {source === 'bulletin' &&
          bulletinBiddingComments()?.map((comment) => (
            <CommentItem
              key={comment.id}
              id={comment.id}
              contact_client_id={comment.contact_client.id}
              contact_client_nome={comment.contact_client.nome}
              created_at={comment.created_at}
              message={comment.message}
              biddingId={biddingId.toString()}
              commentSource={source}
              bulletinFilterId={bulletinFilterId}
            />
          ))}
        <div className="row">
          <div className="col-md-12 mt-1">
            <CommentInput
              isLoading={
                source === 'bulletin'
                  ? bulletin_comments_request[biddingId]?.create_comment_bulletin?.loading
                  : comments_request[biddingId]?.create_comment?.loading
              }
              createComment={createBiddingComment}
              commentSource={source}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiddingCommentsList;
